import { customerDataResponse } from '../customer/customer.types';
import { CartItemDataType } from './cartItem.types';
import { CartModifierGroup, Item, Tag } from '../menu/menu.types';
import { allergenData } from '../menu/allergen.types';
import { IMetaData, OrderType, ServeType, StatusType, OrderDataType } from '../ticket/ticket.types';
import { RestaurantTimingDataType } from '../restaurant/restaurantTiming.types';
import { LocationRequestType } from '../location/location.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { ticketItemDataResponse } from '../ticket/ticketItem.types';
import { PaymentType } from '../payment/payment.types';
export interface CartRequestType {
  customerUsername: string;
  restaurantId: number;
  estimated_time_slot: RestaurantTimingDataType;
  locationId: number;
  order_type: OrderType;
  apartment: string;
  latitude: number;
  longitude: number;
}

export interface CartDatatype {
  id: number;
  items: CartItemDataType[];
  customer?: customerDataResponse | null;
  totalBill: number;
  actualPrice?: number;
  estimatedTimeSlot: RestaurantTimingDataType;
  location: LocationRequestType;
  restaurant?: RestaurantResponseType;
  order?: OrderDataType;
  createdAt: Date;
  updatedAt: Date;
  pickupTime?: string;
  quantity?: number;
  isScheduledOrder?: boolean;
  scheduledDateTime?: string | Date;
  order_type: OrderType;
}

export interface CartCheckoutStatus {
  id?: number;
  orderStatus?: string;
  pickupTime?: string;
  delayTime?: number;
}

export interface CartOrderResponse {
  id: number;
  status: StatusType;
  createdAt: Date;
  updatedAt: Date;
}

export interface CartTicketResponse {
  tokens?: { accessToken: string | undefined; idToken: string | undefined };
  ticket?: CartTicketDataResponse;
  cart?: CartDatatype | null;
  payment?: PaymentType;
  order?: CartOrderResponse | null;
  customer?: customerDataResponse | null;
}

export interface CartTicketDataResponse {
  ticketNumber: number;
  restaurant: RestaurantResponseType;
  status: StatusType;
  enum?: OrderType;
  note: string;
  orderSource: string;
  ticketPaymentStatus: string;
  orderTracking: string;
  orderStatus: string;
  stationStatus?: string;
  // employeeId: string;
  tableNumber: number;
  serveType: ServeType;
  noOfGuests: number;
  taxExemption: boolean;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  ticketItems: ticketItemDataResponse[];
  isOpenTab: boolean;
  openTabName: string;
  authorizedLimit: number;
}

export interface CartTicketResponseType {
  data: CartTicketResponse | null;
  message: string;
  success: boolean;
}

export interface CartResponseType {
  data: { cart: CartDatatype; tokens?: { AccessToken: string; IdToken: string } } | null;
  message: string;
  success: boolean;
}

export interface CartsResponseType {
  data: { cart: CartDatatype[]; tokens?: { AccessToken: string; IdToken: string } } | null;
  message: string;
  success: boolean;
}

export interface CartCheckoutStatusResponseType {
  data: CartCheckoutStatus | null;
  message: string;
  success: boolean;
}

export interface CartsStatusResponseType {
  data: CartCheckoutStatus[] | null;
  message: string;
  success: boolean;
}

export interface OrderCartsResponseType {
  data: OrderDataType | null;
  message: string;
  success: boolean;
}

export enum CartStatus {
  ACTIVE = 'active',
  CHECKED_OUT = 'checked-out',
  HOLD = 'hold',
  TIMED_OUT = 'timed-out',
}

export enum NuggetEventType {
  payment_info = 'payment_info',
  payment_success = 'payment_success',
  payment_fail = 'payment_fail',
  payment_progress = 'payment_progress',
  user_activity_continued = 'user_activity_continued',
  user_inactive = 'user_inactive',
  session_expire_warning = 'session_expire_warning',
  session_expired = 'session_expired',
  order_fulfilled = 'order_fulfilled',
}

export interface PrepareCartAddOnsDataType {
  id: number;
  itemName: string;
  itemPicture: string;
  itemPrice: number;
  isDiscount: boolean;
  discountPercentage: number;
  orderedQuantity: number;
  stockStatus: string | null;
}

export interface PrepareCartItemDataType {
  id: number;
  itemName?: string;
  itemPrice: number;
  orderedQuantity: number;
  isDiscount: boolean;
  discountPercentage: number;
  special_instructions?: string;
  tag: Tag[];
  allergen: allergenData[];
  optionalModifierGroups?: CartModifierGroup[];
  requiredModifierGroups: CartModifierGroup[];
  selectedModifierGroups: CartModifierGroup[];
  addOns: PrepareCartAddOnsDataType[];
  metaDataKiosk?: IMetaData;
  metaData: PrepareCartItemDataType;
  itemId: number;
  item: Item;
  cart_item_id?: number;
  isLoyaltyApplied?: boolean;
  loyaltyAmountApplied?: number;
  loyaltyItemId?: number;
  actualPrice?: number;
}

export interface CustomerCartCartRequestType {
  apartment?: string;
  latitude?: number;
  longitude?: number;
  metaDataKiosk?: IMetaData;
}

export interface PrepareCartRequestType {
  items: PrepareCartItemDataType[];
  totalBill: number;
  actualPrice: number;
  customerUsername: string;
  estimatedTimeSlotId: number;
  delivery_address?: string;
  order_type?: OrderType;
  apartment?: string;
  latitude?: number;
  longitude?: number;
  includeUtensils?: boolean;
  note?: string;
  dealId?: number;
}

export interface ReorderItemsRequestType {
  cartItemsIds: number[];
  restaurantId: number;
  customerUsername: string;
  estimatedTimeSlotId: number;
  delivery_address?: string;
  order_type?: OrderType;
}

export interface PrepareKioskCartRequestType {
  items?: PrepareCartItemDataType[];
  totalBill: number;
  order_type?: OrderType;
  includeUtensils?: boolean;
  note?: string;
  kioskId?: number;
  //totalTax
  actualPrice: number;
}

export interface UpdateCartRequestType {
  restaurantId?: number;
  estimatedTimeSlotId?: number;
  delivery_address?: string;
  order_type?: OrderType;
  apartment?: string;
  latitude?: number;
  longitude?: number;
}
export interface PaymentInfoInterface {
  totalBill: number;
  discountedPrice: number;
  actualPrice: number;
  totalTax: number;
  totalServiceCharge: number;
  discount: number;
  gratuityChargesAmount: number;
  nonRevenueinReportChargesAmount: number;
  totalServiceChargeTaxAmount: number;
  itemDiscountedPrice?: number;
  giftCardAmount?: number;
  itemLevelDealDiscount?: number;
  redeemedPoints?: number;
  pointsEarned?: number;
  discountInfo?: IDiscountInfo;
  actualTax?: number;
  adjustAuthorisationData?: Record<string, any>;
  tipAmount?: number;
}

export interface IDiscountInfo {
  type?: string;
  value?: number;
  name?: string;
  posName?: string;
}

export interface PaymentInfo extends PaymentInfoInterface {
  tipAmount: number;
  platformFee: number;
  deliveryFeeInDollars: number;
  totalConvenienceFee: number;
  lastConvenienceFee: number;
  lastPaidAmount: number;
  paidAmount: number;
  remainingAmount: number;
  cardNetSales: number;
  cashNetSales: number;
  tipAdded: boolean;
  giftCardAmount?: number;
  is_gift_card_applied?: boolean;
  serviceChargeBreakdown: { [key: string]: number };
  entireDealDiscount?: number;
  isTaxInclusive?: boolean;
  actualPriceTaxInclusive?: number;
  discountedPriceTaxInclusive?: number;
  redeemedPoints?: number;
  pointsEarned?: number;
  ticketItemDiscountedPrice?: number;
  adjustAuthorisationData?: Record<string, any>;
  serviceId?: string;
  saleId?: number;
  commission?: number;
  payout?: number;
  other_fee?: any;
  tax_payout?: number;
  orderDelay?: number;
  estimatedTime?: number;
  // 3PO payment types which stored in paymentInfo
  subtotal: string;
  tax: string;
  restaurant_tip_amount: string | null;
  adjustment: string | null;
  tips: string;
  delivery_fee: string | null;
  service_fee: string | null;
  processing_fee: string | null;
  intentId?: Record<number, string>;
}

export interface IDs {
  menuIds: number[];
  categoryIds: number[];
  itemIds: number[];
}

export enum TipType {
  FIXED = 'fixed',
  PERCENT = 'percent',
}

export interface NuggetCartResponseType {
  data: { token: string } | null;
  message: string;
  success: boolean;
}

export interface NuggetCartDataType {
  totalServiceCharge: number;
  totalTax: number;
  totalBill: number;
  tipAmount: number;
}
